export const HOME = '/'
export const DEFAULT = '/*'
export const SIGN_UP = '/sign-up'
export const SIGN_IN = '/login'
export const SIGN_OUT = '/sign-out'
export const RECOVER_PASSWORD = '/recover-password/:id'
export const TERMPRIVACYPOLICY = '/term-privacy-policy'
export const CREATED_SUCCESS = '/login/:status'
